import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const N = { navy:'#20396B', bubblegum:'#F2A7C0', blush:'#FBDDE6', cream:'#FCF6EC', sunny:'#FFC84B', teal:'#36B7A6', tealLight:'#d0f0ec', white:'#fff' };

export default function ParentPortal({ studentId, studentName, onLogout }) {
  const [weeklyUpdate, setWeeklyUpdate] = useState(null);
  const [materials, setMaterials] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      const { data: wu } = await supabase.from('weekly_updates').select('*').eq('student_id', studentId).order('created_at',{ascending:false}).limit(1).single();
      setWeeklyUpdate(wu);
      const { data: mat } = await supabase.from('materials').select('*').eq('student_id', studentId).order('created_at',{ascending:false});
      setMaterials(mat||[]);
    };
    fetchAll();
  }, [studentId]);

  const card = (bg) => ({ background:bg||N.white, borderRadius:16, padding:'20px 22px', boxShadow:'0 2px 10px rgba(32,57,107,0.07)', marginBottom:16 });

  return (
    <div style={{ minHeight:'100vh', background:N.cream }}>
      <div style={{ background:N.navy, padding:'14px 24px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:22 }}>🐰</span>
          <div>
            <div style={{ fontFamily:'var(--font-head)', fontSize:17, fontWeight:700, color:'#fff' }}>OkieDokie Academy</div>
            <div style={{ fontSize:12, color:N.bubblegum, fontWeight:700 }}>Parent view — {studentName}</div>
          </div>
        </div>
        <button onClick={onLogout} style={{ background:'rgba(255,255,255,0.15)', border:'none', borderRadius:10, padding:'7px 14px', cursor:'pointer', fontSize:12, color:'#fff', fontFamily:'var(--font-body)', fontWeight:600 }}>Log out</button>
      </div>

      <div style={{ padding:'28px 24px', maxWidth:700, margin:'0 auto' }}>
        <div style={card(N.blush)}>
          <div style={{ fontFamily:'var(--font-head)', fontSize:17, fontWeight:700, color:N.navy, marginBottom:10 }}>📋 What we covered this lesson</div>
          {weeklyUpdate?.lesson_goals ? (
            <>
              <div style={{ fontSize:14, lineHeight:1.8, whiteSpace:'pre-wrap', color:N.navy }}>{weeklyUpdate.lesson_goals}</div>
              {weeklyUpdate.updated_at && <div style={{ fontSize:11, color:'#8a9ab8', marginTop:8, fontWeight:600 }}>Updated: {new Date(weeklyUpdate.updated_at).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})}</div>}
            </>
          ) : <div style={{ color:'#8a9ab8', fontSize:13 }}>Nothing posted yet.</div>}
        </div>

        <div style={card(N.tealLight)}>
          <div style={{ fontFamily:'var(--font-head)', fontSize:17, fontWeight:700, color:N.navy, marginBottom:10 }}>✏️ Homework</div>
          {weeklyUpdate?.homework ? (
            <div style={{ fontSize:14, lineHeight:1.8, whiteSpace:'pre-wrap', color:N.navy }}>{weeklyUpdate.homework}</div>
          ) : <div style={{ color:'#8a9ab8', fontSize:13 }}>No homework posted yet.</div>}
        </div>

        <div style={card()}>
          <div style={{ fontFamily:'var(--font-head)', fontSize:17, fontWeight:700, color:N.navy, marginBottom:12 }}>📁 Lesson Materials</div>
          {materials.length === 0 && <div style={{ color:'#8a9ab8', fontSize:13 }}>No materials uploaded yet.</div>}
          {materials.map(mat => (
            <div key={mat.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 0', borderBottom:`1px solid ${N.blush}` }}>
              <span style={{ fontSize:20 }}>📄</span>
              <a href={mat.file_url} target="_blank" rel="noreferrer" style={{ color:N.teal, fontSize:14, fontWeight:700, textDecoration:'none' }}>{mat.file_name}</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
